/*
 * Copyright (c) Nexign, JSC, 2023-2025.
 */
/**
 * Product Card Tariff wrapper
 *
 * @author Evgeniy Naumov
 * @author Nikolay Sviridov
 * @version 1.37.0
 * @since 1.23.0
 */

import { IPageProductsTranslation } from '@modules/internationalization/types/pages/products';

import {
    ICardTariffNewItem,
    IProductCardTariff,
    IProductCardTariffSetRange,
} from '../../tariffsAndServicesProductTariffTypes';
import TariffCardNew from './TariffCards/TariffCardNew';

export const PRODUCT_CARD_TARIFF_UNLIMITED_VALUE = 99999;

export interface IProductCardTariffProps {
    pageProductTranslation: IPageProductsTranslation;
    showRangeTooltip: boolean;

    setRange: (payload: IProductCardTariffSetRange) => void;
}

export type TProductCardTariffClassicProps = IProductCardTariff & IProductCardTariffProps;
export type TProductCardTariffNewProps = ICardTariffNewItem & Omit<IProductCardTariffProps, 'showRangeTooltip'>;

export type TProductCardTariff = TProductCardTariffClassicProps | TProductCardTariffNewProps;

export const ProductCardTariff = (props: TProductCardTariff) => {

    return <TariffCardNew {...(props as TProductCardTariffNewProps)} />;
};

export default ProductCardTariff;
